var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "separable" }, [
    _c(
      "div",
      { staticClass: "marginTop container" },
      [
        _vm.showSincronizar
          ? _c("sincronizar-processo", {
              on: {
                carregaProcessos: _vm.carregaProcessos,
                cancelar: function($event) {
                  _vm.showSincronizar = false
                }
              }
            })
          : _vm._e(),
        _c(
          "el-row",
          [
            _c("el-col", { staticClass: "cardProcesso", attrs: { span: 24 } }, [
              _c("div", { staticClass: "card" }, [
                _c(
                  "div",
                  { staticClass: "card-header titulo" },
                  [
                    _vm._v("Processos existentes"),
                    _vm.isCentral
                      ? _c(
                          "el-button",
                          {
                            staticClass: "buttonProcesso",
                            attrs: { type: "primary" },
                            on: {
                              click: function($event) {
                                _vm.showSincronizar = true
                              }
                            }
                          },
                          [
                            _c("span", { staticClass: "center" }, [
                              _c("i", { staticClass: "fal fa-sync-alt" }),
                              _vm._v("  Sincronizar processo")
                            ])
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "marginDivider" },
                  [
                    _c("app-divider-refresh-button", {
                      attrs: {
                        label: _vm.headerLabel,
                        hasButton: _vm.hasRefreshButton,
                        content: _vm.tooltipRefreshButton,
                        showBorder: false
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "card-body" },
                  [
                    _c("el-row", [_c("div", { staticClass: "divider" })]),
                    _c(
                      "div",
                      { staticClass: "table-pointer" },
                      [
                        _c(
                          "el-table",
                          {
                            staticStyle: { cursor: "pointer" },
                            attrs: {
                              data: _vm.processos,
                              "default-sort": {
                                prop: "id",
                                order: "descending"
                              }
                            },
                            on: {
                              "sort-change": _vm.sort,
                              "row-click": _vm.goTo
                            }
                          },
                          [
                            !_vm.isBusca
                              ? _c("template", { slot: "empty" }, [
                                  _vm._v("Não há registros.")
                                ])
                              : _c("template", { slot: "empty" }, [
                                  _vm._v("Não há registros.")
                                ]),
                            _c("el-table-column", {
                              attrs: { "min-width": "40" },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c("div", { staticClass: "green" }, [
                                        _c("i", {
                                          staticClass: "fal fa-eye",
                                          staticStyle: { "margin-left": "10px" }
                                        })
                                      ])
                                    ]
                                  }
                                }
                              ])
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "numeroProcesso",
                                label: "Processo",
                                "min-width": "120"
                              }
                            }),
                            _c("el-table-column", {
                              attrs: {
                                label: "CPF/CNPJ do interessado",
                                "min-width": "195",
                                prop: "cpfCnpjInteressado",
                                formatter: _vm.formatCpfCnpj
                              }
                            }),
                            _c("el-table-column", {
                              attrs: {
                                label: "Nome/Razão social do interessado",
                                prop: "nomeRazaoSocialInteressado",
                                "min-width": "265",
                                sortable: "sortable"
                              }
                            }),
                            _c("el-table-column", {
                              attrs: {
                                label: "Munícipio",
                                prop: "municipio",
                                "min-width": "130",
                                sortable: "sortable"
                              }
                            }),
                            _vm.isCentral
                              ? _c("el-table-column", {
                                  attrs: {
                                    label: "Tipo de processo",
                                    prop: "tipo.nome",
                                    sortable: "sortable",
                                    "min-width": "130"
                                  }
                                })
                              : _vm._e(),
                            !_vm.isCentral
                              ? _c("el-table-column", {
                                  attrs: {
                                    label: "Tipo de processo",
                                    prop: "tipo",
                                    sortable: "sortable",
                                    "min-width": "130"
                                  }
                                })
                              : _vm._e(),
                            _c("el-table-column", {
                              attrs: {
                                label: "Status",
                                prop: "status",
                                "min-width": "115",
                                sortable: "sortable"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.setStatusProcesso(scope.row)
                                          )
                                        )
                                      ])
                                    ]
                                  }
                                }
                              ])
                            })
                          ],
                          2
                        )
                      ],
                      1
                    ),
                    _vm._t("default")
                  ],
                  2
                )
              ])
            ])
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-556be480", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-556be480","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/processos/ListagemProcessos.vue
// module id = null
// module chunks = 